module.exports = __webpack_public_path__ + "miscusi-static/fonts/icomoon.a1fba7c90a92efc2503a2a020d2bc4ca.eot";